import { use } from 'react'

import { UserContext } from '../../constants'

const useUser = () => {
	const context = use(UserContext)

	if (!context) {
		throw new Error('useUser must be used within a UserProvider')
	}

	return context
}

export default useUser
